// Mock data for FoxPress Studios website

export const proofReelHighlights = [
  {
    title: "Curated Book-to-Film Design Bible",
    whatItIs: "A visual reference document showing character designs, settings, tone, and style direction. Your book's cinematic blueprint.",
    howItsUsed: "Used to communicate your book's visual identity to studios, collaborators, and fans. The foundation for all other visual materials.",
    whyItMatters: "Your most unique asset. Nobody else offers this. It makes abstract story elements concrete and shareable, becoming the centerpiece of your visual development package.",
    videoUrl: null,
    pdfUrl: `/api/pdf/design-bible`,
    featured: true
  },
  {
    title: "Premium Book Trailer",
    whatItIs: "A 60-90 second cinematic video that presents your book as a visual narrative, built for social sharing.",
    howItsUsed: "Shared on social media, author websites, Amazon pages, and book marketing campaigns to attract readers.",
    whyItMatters: "Visual storytelling captures attention faster than text alone. The most effective book marketing asset you can own.",
    videoUrl: "https://www.youtube.com/embed/Em9mE8Ypb8k"
  },
  {
    title: "Concept Trailer for Authors",
    whatItIs: "A 2-3 minute trailer combining cinematic footage, motion graphics, and storytelling techniques.",
    howItsUsed: "Demonstrates how your story could translate to screen. Perfect for author websites, investor presentations, and adaptation conversations.",
    whyItMatters: "Shows rather than tells what your book looks like in motion, giving adaptation conversations a visual foundation.",
    videoUrl: "https://www.youtube.com/embed/0YVhRxQ1O6M"
  },
  {
    title: "Proof-of-Concept Scene Reel",
    whatItIs: "A collection of filmed key scenes that showcase dramatic moments from your book.",
    howItsUsed: "Acts as visual evidence of your story's screen potential and narrative strength. Ideal for building audience excitement.",
    whyItMatters: "Transforms written scenes into watchable content that proves cinematic viability. Your story, visualized.",
    videoUrl: "https://www.youtube.com/embed/YDXOioU_OKM"
  }
];

export const educationCards = [
  {
    id: 1,
    title: "Packaging beats pitching",
    description: "A polished trailer communicates more in 90 seconds than a 40-page deck ever will. Visual proof cuts through the noise.",
    image: "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&h=600&fit=crop"
  },
  {
    id: 2,
    title: "Traction lowers risk",
    description: "When your book already has an audience watching trailers and shorts, buyers see validation, not just potential.",
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?w=800&h=600&fit=crop"
  },
  {
    id: 3,
    title: "Proof-of-concept communicates tone",
    description: "The vibe, pacing, and world-building become tangible. Decision-makers can finally see what you've been describing.",
    image: "https://images.unsplash.com/photo-1577190651915-bf62d54d5b36?w=800&h=600&fit=crop"
  },
  {
    id: 4,
    title: "Audience-first distribution",
    description: "Build fans before the deal. Every view, share, and comment is data that proves your story has legs.",
    image: "https://images.unsplash.com/photo-1683721003111-070bcc053d8b?w=800&h=600&fit=crop"
  },
  {
    id: 5,
    title: "Visual development bible = consistency",
    description: "A design system ensures every piece of content, from social posts to pitch decks, feels cohesive and professional.",
    image: "https://images.unsplash.com/photo-1602576666092-bf6447a729fc?w=800&h=600&fit=crop"
  },
  {
    id: 6,
    title: "The 'stage' matters more than the book",
    description: "What you're selling isn't pages. It's a cinematic experience. Show them the world, the characters, the stakes.",
    image: "https://images.unsplash.com/photo-1739433437912-cca661ba902f?w=800&h=600&fit=crop"
  }
];

export const roadmapModules = [
  {
    icon: "BookOpen",
    title: "Introduce the Story",
    goal: "Establish your book's core narrative in a format designed for immediate engagement.",
    howUsed: "Short trailers and narrative ads are shared across social platforms, book websites, and email campaigns to attract attention and generate curiosity.",
    whyItMatters: "Visual introduction creates faster recognition than text descriptions and provides shareable content that extends your book's reach beyond traditional channels.",
    image: "https://images.unsplash.com/photo-1578879972681-eb9319ba5163?w=800&h=600&fit=crop"
  },
  {
    icon: "Palette",
    title: "Define the Visual Identity",
    goal: "Establish consistent visual language that communicates your story's tone, style, and world.",
    howUsed: "Design references, character boards, and style guides are used in marketing materials, presentation decks, and promotional assets to maintain unified branding.",
    whyItMatters: "Visual consistency strengthens recognition and makes your story more memorable across all touchpoints where readers and audiences encounter it.",
    image: "https://images.pexels.com/photos/7661590/pexels-photo-7661590.jpeg?w=800&h=600&fit=crop"
  },
  {
    icon: "Sparkles",
    title: "Elevate the Experience",
    goal: "Create immersive content that demonstrates cinematic potential and emotional impact.",
    howUsed: "Augmented trailers and scene reels are featured in author platforms, book launches, and promotional campaigns to showcase production value and narrative depth.",
    whyItMatters: "High-quality cinematic content positions your work as screen-ready and creates differentiation in a crowded marketplace.",
    image: "https://images.unsplash.com/photo-1611540881474-bf7c8731bfd2?w=800&h=600&fit=crop"
  },
  {
    icon: "TrendingUp",
    title: "Sustain Visibility",
    goal: "Maintain ongoing presence through adaptable content that continues working after initial launch.",
    howUsed: "Repurposed clips, behind-the-scenes content, and modular video segments are deployed across channels over time to keep your story active and discoverable.",
    whyItMatters: "Sustained content presence keeps your book relevant, supports long-tail discovery, and maintains momentum beyond the initial release window.",
    image: "https://images.unsplash.com/photo-1759215524472-1b0686fdbd87?w=800&h=600&fit=crop"
  }
];

export const proofLibraryItems = [
  // New YouTube videos at the top
  {
    id: 105,
    title: "The Ultimate Quest",
    videoUrl: "https://www.youtube.com/embed/uwVVbpkWuLU",
    thumbnail: "https://img.youtube.com/vi/uwVVbpkWuLU/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 106,
    title: "Cinematic Trailer",
    videoUrl: "https://www.youtube.com/embed/uzem6ErOcIE",
    thumbnail: "https://img.youtube.com/vi/uzem6ErOcIE/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 107,
    title: "Book Trailer Showcase",
    videoUrl: "https://www.youtube.com/embed/3LFK91oJyAw",
    thumbnail: "https://img.youtube.com/vi/3LFK91oJyAw/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 108,
    title: "Visual Development Reel",
    videoUrl: "https://www.youtube.com/embed/RfhjpTRlBLI",
    thumbnail: "https://img.youtube.com/vi/RfhjpTRlBLI/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 101,
    title: "Cinematic Spotlight #1",
    videoUrl: "https://www.youtube.com/embed/Em9mE8Ypb8k",
    thumbnail: "https://img.youtube.com/vi/Em9mE8Ypb8k/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 102,
    title: "Cinematic Spotlight #2",
    videoUrl: "https://www.youtube.com/embed/URiNzgkSqpA",
    thumbnail: "https://img.youtube.com/vi/URiNzgkSqpA/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 103,
    title: "Cinematic Spotlight #3",
    videoUrl: "https://www.youtube.com/embed/lNISgiD4TIw",
    thumbnail: "https://img.youtube.com/vi/lNISgiD4TIw/maxresdefault.jpg",
    type: "youtube"
  },
  {
    id: 104,
    title: "Cinematic Spotlight #4",
    videoUrl: "https://www.youtube.com/embed/JVSYVzWzGr4",
    thumbnail: "https://img.youtube.com/vi/JVSYVzWzGr4/maxresdefault.jpg",
    type: "youtube"
  },
  // Existing portfolio items
  {
    id: 1,
    title: "Gaining the High Ground Over Evolutionism",
    videoUrl: "https://drive.google.com/file/d/1FfnQrkpMwjciAs-eFptLIoT1JEzztpvw/preview",
    thumbnail: "https://customer-assets.emergentagent.com/job_visuals-studio-2/artifacts/4pir7wni_1..jpg",
    type: "gdrive"
  },
  {
    id: 2,
    title: "CUBAN LIGHTNING VISUAL TEASER",
    videoUrl: "https://drive.google.com/file/d/1-fn3cHii6-LeoFanJNVPq-L0A-p3z6q6/preview",
    thumbnail: "https://customer-assets.emergentagent.com/job_visuals-studio-2/artifacts/sogj3j75_Cuban.jpg",
    type: "gdrive"
  },
  {
    id: 3,
    title: "Valley Egypt",
    videoUrl: "https://drive.google.com/file/d/16Ve_y43FI9h-9ZOYHiC0s0HptpGV2Kpw/preview",
    thumbnail: "https://customer-assets.emergentagent.com/job_visuals-studio-2/artifacts/ae8ljper_Valley.jpg",
    type: "gdrive"
  },
  {
    id: 4,
    title: "SWARM - Guy Garcia",
    videoUrl: "https://drive.google.com/file/d/1q-uIfWWNQHc2BcUVipD9XDb0aWLocDYx/preview",
    thumbnail: "https://customer-assets.emergentagent.com/job_visuals-studio-2/artifacts/fbcl2zt1_swarm.jpg",
    type: "gdrive"
  },
  {
    id: 5,
    title: "The Distant Lighthouse",
    videoUrl: "https://drive.google.com/file/d/1yfwxvrOCulPb6OIXC6ueidJ5V8wRqdxb/preview",
    thumbnail: "https://customer-assets.emergentagent.com/job_visuals-studio-2/artifacts/p3x6tlqk_Distant.jpg",
    type: "gdrive"
  },
  {
    id: 6,
    title: "The Distant Lighthouse Teaser Video",
    videoUrl: "https://customer-assets.emergentagent.com/job_visuals-studio-2/artifacts/4xyd9l5d_TDL-%20Video%201%20%28Remembering%20Family%29.mp4",
    thumbnail: "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=800&h=450&fit=crop",
    type: "mp4"
  }
];

export const processSteps = [
  {
    number: "01",
    title: "Align",
    description: "We discuss your book, identify key visual moments, and define which materials fit your goals and timeline.",
    icon: "MessageSquare"
  },
  {
    number: "02",
    title: "Create",
    description: "Production begins on the agreed materials: trailers, design references, or scene content, all tailored to your story.",
    icon: "Clapperboard"
  },
  {
    number: "03",
    title: "Use",
    description: "You receive finished assets ready to share across platforms, campaigns, and promotional channels as needed.",
    icon: "Share2"
  }
];

export const mainProofReelVideo = {
  title: "FoxPress Studios - Showreel 2024",
  videoUrl: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  thumbnail: "https://images.unsplash.com/photo-1574267432644-f610f5ac3b19?w=1200&h=675&fit=crop"
};